/**
 * Gets the total number of assignees for a poll's assignment.
 * Assignees are either assigned to classrooms or student groups. Data shape will vary
 * depending on which it is, so first we determine which assignee type it is so we can
 * handle each one accordingly.
 *
 * @param {object} assignment
 * @param {array} teacherClassrooms
 * @returns {number} count
 */
const getTotalAssigneesForPolls = (assignment, teacherClassrooms) => {
  const assignedToClassrooms = assignment.assignment_classrooms.length;
  const assignedToStudentGroups = assignment.assignment_groups.length;

  if (assignedToClassrooms) {
    return assignment.assignment_classrooms.reduce((acc, classroom) => {
      const classId = classroom.classroom.id;
      const matchedClassroom = teacherClassrooms.find(
        (classroom) => classroom.id === classId,
      );
      const amountOfStudentsInClassroom =
        matchedClassroom?.enrollments?.length ?? 0;

      return acc + amountOfStudentsInClassroom;
    }, 0);
  }

  if (assignedToStudentGroups) {
    return assignment.assignment_groups.reduce(
      (acc, group) => acc + group.users.length,
      0,
    );
  }
};

export default getTotalAssigneesForPolls;
